/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HandlersWindVelocityHeader
 */
export interface HandlersWindVelocityHeader {
    /**
     * 
     * @type {number}
     * @memberof HandlersWindVelocityHeader
     */
    dx?: number;
    /**
     * 
     * @type {number}
     * @memberof HandlersWindVelocityHeader
     */
    dy?: number;
    /**
     * 
     * @type {number}
     * @memberof HandlersWindVelocityHeader
     */
    la1?: number;
    /**
     * 
     * @type {number}
     * @memberof HandlersWindVelocityHeader
     */
    la2?: number;
    /**
     * 
     * @type {number}
     * @memberof HandlersWindVelocityHeader
     */
    lo1?: number;
    /**
     * 
     * @type {number}
     * @memberof HandlersWindVelocityHeader
     */
    lo2?: number;
    /**
     * 
     * @type {number}
     * @memberof HandlersWindVelocityHeader
     */
    nx?: number;
    /**
     * 
     * @type {number}
     * @memberof HandlersWindVelocityHeader
     */
    ny?: number;
    /**
     * 
     * @type {number}
     * @memberof HandlersWindVelocityHeader
     */
    parameterCategory?: number;
    /**
     * 
     * @type {number}
     * @memberof HandlersWindVelocityHeader
     */
    parameterNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof HandlersWindVelocityHeader
     */
    parameterNumberName?: string;
    /**
     * 
     * @type {string}
     * @memberof HandlersWindVelocityHeader
     */
    parameterUnit?: string;
    /**
     * 
     * @type {string}
     * @memberof HandlersWindVelocityHeader
     */
    refTime?: string;
}

/**
 * Check if a given object implements the HandlersWindVelocityHeader interface.
 */
export function instanceOfHandlersWindVelocityHeader(value: object): boolean {
    return true;
}

export function HandlersWindVelocityHeaderFromJSON(json: any): HandlersWindVelocityHeader {
    return HandlersWindVelocityHeaderFromJSONTyped(json, false);
}

export function HandlersWindVelocityHeaderFromJSONTyped(json: any, ignoreDiscriminator: boolean): HandlersWindVelocityHeader {
    if (json == null) {
        return json;
    }
    return {
        
        'dx': json['dx'] == null ? undefined : json['dx'],
        'dy': json['dy'] == null ? undefined : json['dy'],
        'la1': json['la1'] == null ? undefined : json['la1'],
        'la2': json['la2'] == null ? undefined : json['la2'],
        'lo1': json['lo1'] == null ? undefined : json['lo1'],
        'lo2': json['lo2'] == null ? undefined : json['lo2'],
        'nx': json['nx'] == null ? undefined : json['nx'],
        'ny': json['ny'] == null ? undefined : json['ny'],
        'parameterCategory': json['parameterCategory'] == null ? undefined : json['parameterCategory'],
        'parameterNumber': json['parameterNumber'] == null ? undefined : json['parameterNumber'],
        'parameterNumberName': json['parameterNumberName'] == null ? undefined : json['parameterNumberName'],
        'parameterUnit': json['parameterUnit'] == null ? undefined : json['parameterUnit'],
        'refTime': json['refTime'] == null ? undefined : json['refTime'],
    };
}

export function HandlersWindVelocityHeaderToJSON(value?: HandlersWindVelocityHeader | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'dx': value['dx'],
        'dy': value['dy'],
        'la1': value['la1'],
        'la2': value['la2'],
        'lo1': value['lo1'],
        'lo2': value['lo2'],
        'nx': value['nx'],
        'ny': value['ny'],
        'parameterCategory': value['parameterCategory'],
        'parameterNumber': value['parameterNumber'],
        'parameterNumberName': value['parameterNumberName'],
        'parameterUnit': value['parameterUnit'],
        'refTime': value['refTime'],
    };
}

